import * as React from "react";
import {
  displayHeaderCartoon,
  determineAnimTitle
} from "../../utils/uiOverrides";
import Loader from "../../components/loader";
import { options } from "../../components/loader/options";
import { HeaderImageParams } from "../../constants/headerImageParams";
import { stepImageForFieldID } from "../../constants/images";
import injectSheet from "react-jss";

interface Props {
  currentStep: number;
  fieldIDs: string[];
  currentStepId: any;
  currentImage: any;
  classes?: any;
}

const styleSheet = {
  stepAnim: {
    marginBottom: "60px",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    alignContent: "center",
    alignSelf: "center",
    "& div#loader": {
      maxWidth: "360px"
    },
    "@media (max-width: 767px)": {
      display: "none"
    }
  },
  imageHolder: {
    maxWidth: "360px",
    margin: "0 auto",
    marginBottom: "60px",
    "& img": {
      width: "100%"
    },
    "@media (max-width: 767px)": {
      display: "none"
    },
    "@media (max-height: 700px)": {
      maxWidth: "250px"
    },
    "@media (max-height: 600px)": {
      display: "none"
    }
  }
};

const StepHeader: React.FC<Props> = props => {
  const { currentStepId } = props;
  const displayHeaderCartoonBoolean = displayHeaderCartoon(currentStepId);
  const currentAnimTitle: string = determineAnimTitle(currentStepId);
  const currentHeaderDescriptor: any = HeaderImageParams[currentAnimTitle];
  const currentAnim: any = options[currentAnimTitle];
  const currentStepImage: string = stepImageForFieldID(props.fieldIDs);

  if (!displayHeaderCartoonBoolean) return <div />;
  if (currentHeaderDescriptor && currentHeaderDescriptor.useAnim) {
    return (
      <div className={props.classes.stepAnim} id={"anim-container"}>
        <Loader
          isVisible={true}
          animationData={currentAnim}
          speed={currentHeaderDescriptor.speed}
          loop={currentHeaderDescriptor.loop}
        />
      </div>
    );
  } else {
    return (
      <div className={props.classes.imageHolder}>
        <img
          id={"image-container"}
          className={props.classes.stepImage}
          src={currentStepImage}
          alt=""
        />
      </div>
    );
  }
};

export default injectSheet(styleSheet)(StepHeader);
